module.exports = __webpack_public_path__ + "static/media/marcador.7a6b25ed.svg";